export const AssetActionTypes = {
    API_RESPONSE_SUCCESS: '@@asset/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@asset/API_RESPONSE_ERROR',

    LIST_ASSET: '@@asset/LIST_ASSET',
    SHOW_ASSET: '@@asset/SHOW_ASSET',
    FILTER_ASSET: '@@asset/FILTER_ASSET',
};